/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GuestlistInputs */

const en_nav_guestlist = /** @type {(inputs: Nav_GuestlistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guestlist`)
};

/**
* | output |
* | --- |
* | "Guestlist" |
*
* @param {Nav_GuestlistInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_guestlist = /** @type {((inputs?: Nav_GuestlistInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GuestlistInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_guestlist(inputs)
});